import { Button, Layout, Tooltip } from 'antd'

import { Logo } from '@/components/logo'
import UserGlobalMenu from '../../user-menu'

import ConvocatoriaAddApplication from '@/containers/home/convocatoria/addApplication'
import { AppState, FormState } from '@/state'
import { FaArrowDown, FaArrowUp } from 'react-icons/fa6'
import { appStateActions } from '@/state/actions'

import './styles.scss'

const { Header } = Layout

export const Topbar: React.FC = () => {
  if (AppState.hideTopbar.value)
    return (
      <Tooltip title='Mostrar barra superior' placement='right'>
        <Button
          className='show-topbar-btn'
          onClick={appStateActions.showTopbar}
          icon={<FaArrowDown />}
        />
      </Tooltip>
    )

  const styling: React.CSSProperties = {}

  return (
    <Header className='topbar' style={styling}>
      <div className='topbar-content'>
        <Logo />
        <ConvocatoriaAddApplication />
        {FormState.showForm.value && (
          <Tooltip title='Ocultar barra superior' placement='bottom'>
            <Button
              className='hide-topbar-btn'
              onClick={appStateActions.hideTopbar}
              icon={<FaArrowUp size={20} />}
              shape='circle'
            />
          </Tooltip>
        )}
        <UserGlobalMenu />
      </div>
    </Header>
  )
}
